import Paywall from "@components/Paywall";

import { useFeatureFlag } from "@utils/featureFlags";
import { Redirect, useLocalSearchParams } from "expo-router";

export default function PaywallScreen() {
  const params = useLocalSearchParams<{
    onboarding?: "true";
  }>();

  const { value: onboardingEnabled } = useFeatureFlag("Onboarding");

  // If onboarding is disabled, skip the onboarding paywall
  if (params.onboarding === "true" && !onboardingEnabled) {
    return <Redirect href="/" />;
  }

  return <Paywall />;
}
